// New component created by srini on 02-04-25 for engagement  section

import { useState, useContext } from "react"
import { Grid, Button, styled, Typography } from "@mui/material"
import { withStyles } from "@material-ui/core/styles"
import FileOpenIcon from '@mui/icons-material/FileOpen';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as XLSX from "xlsx";
import { httpRequest } from "../../../../ui-utils/api"
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig"

import styles from './engagementStyles'
import snackError from "../../../../helpers/snackError";
import { reducerContext } from "../../../../contextApi's/contextApi's";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    width: 0.5,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
})


const Upload = ({ classes }) => {

    const { dispatch } = useContext(reducerContext)

    const [fileName, setFileName] = useState("")
    const [enable, setEnable] = useState(false)
    const [fileData, setFileData] = useState([])

    const handleFileChange = (e) => {
        const file = e.target.files[0]

        if (e.target.files.length > 0) {
            setFileName(file.name);
        }

        if (file) {
            const fileType = file.name.split(".").pop()
            if (fileType !== "xls" && fileType !== "xlsx") {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Please select a valid Excel file (.xls or .xlsx)' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                e.target.value = null;
                return;
            }

            const reader = new FileReader()
            reader.readAsArrayBuffer(file)

            reader.onload = (event) => {
                const arrayBuffer = event.target.result
                const workbook = XLSX.read(arrayBuffer, { type: "array" })

                const sheetName = workbook.SheetNames[0]
                const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

                const formattedData = sheet
                    .filter(row => row.length > 1) // Ignore empty rows
                    .map(row => ({
                        client_id: row[0],
                        agent_id: row[1]
                    }))

                setFileData(formattedData)
                setEnable(!enable)
            }
        }
    }


    const handleFileUpload = async () => {
        if (fileData.length === 0) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Please select a valid Excel file.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            return;
        }

        try {
            const engagementUpload = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.engagementUpload}`,
                method: "post",
                instance: "instanceOne",
                requestBody: fileData
            })

            if (engagementUpload.status === 200) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'File uploaded successfully!' })
                setEnable(!enable)
            } else {
                console.error("Upload failed:", engagementUpload)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'File upload failed. Please try again.' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            }

        } catch (error) {
            console.error("Error in Upload API", error)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'File upload failed. Please try again.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
        }
    }


    return (
        <Grid className={classes.uploadGrid} sx={{ marginTop: '30px' }}>
            <Grid className={classes.uploadSubGrid}>
                <Button
                    component="label"
                    className={classes.chooseButton}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<FileOpenIcon />}
                >
                    Choose file
                    <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange}
                        ref={(input) => {
                            if (input) {
                                // Reset the input after the file is selected to allow re-upload of the same file
                                input.value = null;
                            }
                        }}
                    />

                </Button>
            </Grid >
            <Grid className={classes.sendbutton}>
                <Button onClick={handleFileUpload} disabled={!enable} className={enable ? classes.button : classes.disabledButton} startIcon={<CloudUploadIcon />}>Upload</Button>
            </Grid>
            <Grid>
                {fileName && <Typography style={{ marginLeft: "10px" }} className={classes.previewText}>{fileName}</Typography>}
            </Grid>
        </Grid>
    )
}

export default withStyles(styles)(Upload)